<template>
    <div class="mb-2">
        <WarningNotification v-if="outstandingAmount && outstandingAmountFormatted">
            <template #header>
                &pound;{{ outstandingAmountFormatted | currency }} needs to be paid before you move in.
            </template>
            <template #main>
                <p>
                    You can view your charges and past payments.
                </p>
                <p>
                    <b-button
                        type="is-warning"
                        inverted
                        outlined
                        rounded
                        @click.prevent="showModal()"
                    >
                        View
                        <span v-if="$meta.features.tenants.bank_account || $meta.features.tenants.online_payments">and Pay</span>
                    </b-button>
                </p>
            </template>
        </WarningNotification>

        <Notification v-else>
            You don't have any outstanding initial charges.
        </Notification>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import WarningNotification from './WarningNotification.vue';
import TenancyInitialChargesModal from './TenancyInitialChargesModal.vue';
import Notification from './Notification';

export default {
    components: {
        WarningNotification,
        Notification,
    },

    computed: {
        ...mapState('tenancyProperty', [
            'property',
        ]),
        ...mapState('tenancyCharges', [
            'outstandingAmount',
        ]),
        ...mapGetters('tenancyCharges', [
            'outstandingAmountFormatted',
        ]),
    },

    watch: {
        property() {
            this.getOutstandingAmount();
        },
    },

    mounted() {
        this.getOutstandingAmount();
    },

    methods: {
        getOutstandingAmount() {
            this.$store.dispatch('tenancyCharges/getOutstandingAmount', this.property.TenancyFK);
        },
        showModal() {
            this.$buefy.modal.open({
                parent: this,
                component: TenancyInitialChargesModal,
                hasModalCard: true,
            });
        },
    },
};
</script>
